module.exports = __webpack_public_path__ + "img/get-the-research-logo.5e94d155.png";